// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReputationCheckPage__root--ULb5 {
    --risk-color: var(--obscure-color);
    max-width: 632px;
    margin: 0 auto;
}

    .ReputationCheckPage__root--ULb5.ReputationCheckPage__high--qCdj {
        --risk-color: var(--error-color);
    }

    .ReputationCheckPage__root--ULb5.ReputationCheckPage__medium--TEzl {
        --risk-color: var(--warning-color);
    }

    .ReputationCheckPage__root--ULb5.ReputationCheckPage__low--mfY2 {
        --risk-color: var(--success-color);
    }

.ReputationCheckPage__section--NSap {
    padding: 20px;
    background-color: var(--tertiary-color);
    border: 4px solid var(--risk-color);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;
}

.ReputationCheckPage__wrapper--W8Iq {
    width: 100%;
}

.ReputationCheckPage__title--Un87 {
    margin-bottom: 4px;
    font-size: 26px;
    line-height: 34px;
    font-weight: 700;
    color: var(--darkest-color);
}

.ReputationCheckPage__secondaryTitle--mBiQ {
    margin-bottom: 4px;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: var(--darkest-color);
}

.ReputationCheckPage__description--ZTRh {
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: var(--darkest-color);
    margin-bottom: 24px;
}

.ReputationCheckPage__description--ZTRh > strong {
        font-weight: 700;
    }

.ReputationCheckPage__form--yc1F {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.ReputationCheckPage__form--yc1F {
        display: grid;
        grid-template-columns: auto 108px;
        grid-gap: 16px;
        align-items: start
}
    }

.ReputationCheckPage__input--NYGU input {
        border-radius: 48px;
    }

.ReputationCheckPage__button--PmbZ {
    border-radius: 42px;
}

.ReputationCheckPage__riskBlock--ADrX {
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    gap: 12px;
    color: var(--risk-color);
}

.ReputationCheckPage__riskBlockText--fMFY {
    text-shadow: 1px 1px 0px 0px #FFFFFF;
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    text-align: center;
}

.ReputationCheckPage__resultSection--U0bS {
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: var(--obscure-color);
    padding: 4px;
    border-radius: 12px;
}

.ReputationCheckPage__table--Cd0a {
    background-color: var(--tertiary-color);
    border-radius: 12px;
    overflow: hidden;
}

.ReputationCheckPage__tableHead--CmKg {
    padding: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--main-light-color);
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    color: var(--darkest-color);
    border-bottom: 1px solid var(--obscure-color);
}

.ReputationCheckPage__tableRow--PBUG {
    display: grid;
    grid-template-columns: max-content auto max-content;
    grid-gap: 16px;
    padding: 16px 24px;
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    color: var(--secondary-color);
}

.ReputationCheckPage__tableRow--PBUG:not(:last-child) {
        border-bottom: 1px solid var(--obscure-color);
    }

.ReputationCheckPage__tableRow--PBUG > span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 50vw;
    }

.ReputationCheckPage__tableRow--PBUG.ReputationCheckPage__withoutBorder--qn7Z {
        border-bottom: none;
    }

.ReputationCheckPage__riskText--FqQu {
    color: var(--risk-color);
    text-transform: capitalize;
}

.ReputationCheckPage__separator--cU70 {
    height: 16px;
    border-bottom: 1px dotted var(--obscure-color);
}

.ReputationCheckPage__errorText--yaYo {
    color: var(--error-color);
}

.ReputationCheckPage__loader--RDaU {
    display: block;
    margin: 40px auto;
}

.ReputationCheckPage__noteBlock--gXm9 {
    background-color: var(--tertiary-color);
    border: 4px solid var(--obscure-color);
    border-radius: 12px;
    padding: 20px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: var(--secondary-color);
}

.ReputationCheckPage__noteBlock--gXm9 > strong {
        font-weight: 700;
    }
`, "",{"version":3,"sources":["webpack://./src/ui/pages/ReputationCheckPage/ReputationCheckPage.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;AAalB;;IAXI;QACI,gCAAgC;IACpC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;;AAGJ;IACI,aAAa;IACb,uCAAuC;IACvC,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AAKvB;;AAHI;QACI,gBAAgB;IACpB;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AAQb;;AANI;;AALJ;QAMQ,aAAa;QACb,iCAAiC;QACjC,cAAc;QACd;AAER;IADI;;AAIA;QACI,mBAAmB;IACvB;;AAGJ;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sCAAsC;IACtC,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yCAAyC;IACzC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mDAAmD;IACnD,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AAgBjC;;AAdI;QACI,6CAA6C;IACjD;;AAEA;QACI,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;IACnB;;AAEA;QACI,mBAAmB;IACvB;;AAGJ;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;AAKjC;;AAHI;QACI,gBAAgB;IACpB","sourcesContent":[".root {\n    --risk-color: var(--obscure-color);\n    max-width: 632px;\n    margin: 0 auto;\n\n    &.high {\n        --risk-color: var(--error-color);\n    }\n\n    &.medium {\n        --risk-color: var(--warning-color);\n    }\n\n    &.low {\n        --risk-color: var(--success-color);\n    }\n}\n\n.section {\n    padding: 20px;\n    background-color: var(--tertiary-color);\n    border: 4px solid var(--risk-color);\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-bottom: 24px;\n}\n\n.wrapper {\n    width: 100%;\n}\n\n.title {\n    margin-bottom: 4px;\n    font-size: 26px;\n    line-height: 34px;\n    font-weight: 700;\n    color: var(--darkest-color);\n}\n\n.secondaryTitle {\n    margin-bottom: 4px;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    color: var(--darkest-color);\n}\n\n.description {\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 400;\n    color: var(--darkest-color);\n    margin-bottom: 24px;\n\n    > strong {\n        font-weight: 700;\n    }\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    @media (--large), (--small-tablet) {\n        display: grid;\n        grid-template-columns: auto 108px;\n        grid-gap: 16px;\n        align-items: start;\n    }\n}\n\n.input {\n    input {\n        border-radius: 48px;\n    }\n}\n\n.button {\n    border-radius: 42px;\n}\n\n.riskBlock {\n    display: flex;\n    flex-direction: column;\n    padding-top: 24px;\n    gap: 12px;\n    color: var(--risk-color);\n}\n\n.riskBlockText {\n    text-shadow: 1px 1px 0px 0px #FFFFFF;\n    font-weight: 700;\n    font-size: 13px;\n    line-height: 16px;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    text-align: center;\n}\n\n.resultSection {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    background-color: var(--obscure-color);\n    padding: 4px;\n    border-radius: 12px;\n}\n\n.table {\n    background-color: var(--tertiary-color);\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n.tableHead {\n    padding: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: var(--main-light-color);\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 20px;\n    color: var(--darkest-color);\n    border-bottom: 1px solid var(--obscure-color);\n}\n\n.tableRow {\n    display: grid;\n    grid-template-columns: max-content auto max-content;\n    grid-gap: 16px;\n    padding: 16px 24px;\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 20px;\n    color: var(--secondary-color);\n\n    &:not(:last-child) {\n        border-bottom: 1px solid var(--obscure-color);\n    }\n\n    > span {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        max-width: 50vw;\n    }\n\n    &.withoutBorder {\n        border-bottom: none;\n    }\n}\n\n.riskText {\n    color: var(--risk-color);\n    text-transform: capitalize;\n}\n\n.separator {\n    height: 16px;\n    border-bottom: 1px dotted var(--obscure-color);\n}\n\n.errorText {\n    color: var(--error-color);\n}\n\n.loader {\n    display: block;\n    margin: 40px auto;\n}\n\n.noteBlock {\n    background-color: var(--tertiary-color);\n    border: 4px solid var(--obscure-color);\n    border-radius: 12px;\n    padding: 20px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    color: var(--secondary-color);\n\n    > strong {\n        font-weight: 700;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ReputationCheckPage__root--ULb5`,
	"high": `ReputationCheckPage__high--qCdj`,
	"medium": `ReputationCheckPage__medium--TEzl`,
	"low": `ReputationCheckPage__low--mfY2`,
	"section": `ReputationCheckPage__section--NSap`,
	"wrapper": `ReputationCheckPage__wrapper--W8Iq`,
	"title": `ReputationCheckPage__title--Un87`,
	"secondaryTitle": `ReputationCheckPage__secondaryTitle--mBiQ`,
	"description": `ReputationCheckPage__description--ZTRh`,
	"form": `ReputationCheckPage__form--yc1F`,
	"input": `ReputationCheckPage__input--NYGU`,
	"button": `ReputationCheckPage__button--PmbZ`,
	"riskBlock": `ReputationCheckPage__riskBlock--ADrX`,
	"riskBlockText": `ReputationCheckPage__riskBlockText--fMFY`,
	"resultSection": `ReputationCheckPage__resultSection--U0bS`,
	"table": `ReputationCheckPage__table--Cd0a`,
	"tableHead": `ReputationCheckPage__tableHead--CmKg`,
	"tableRow": `ReputationCheckPage__tableRow--PBUG`,
	"withoutBorder": `ReputationCheckPage__withoutBorder--qn7Z`,
	"riskText": `ReputationCheckPage__riskText--FqQu`,
	"separator": `ReputationCheckPage__separator--cU70`,
	"errorText": `ReputationCheckPage__errorText--yaYo`,
	"loader": `ReputationCheckPage__loader--RDaU`,
	"noteBlock": `ReputationCheckPage__noteBlock--gXm9`
};
export default ___CSS_LOADER_EXPORT___;
